module.exports = __webpack_public_path__ + "static/media/0326_Small.990f07d1.jpg";